import * as React from 'react'
import { isShortenedDomainUrl } from '@disco/utils/hostnames'
import ShortlinkNotFound from 'pages/shortlink-not-found'
import { BriefNotFound } from 'features/briefs/pages/not-found'
import NotFoundIllustration from 'components/error-page/assets/icons/not-found.svg'
import styles from './NotFound.module.css'

export default function NotFound(): React.ReactElement | React.ReactNode {
  if (isShortenedDomainUrl()) {
    return <ShortlinkNotFound />
  }

  if (window.location.pathname.startsWith('/brief/')) {
    return <BriefNotFound />
  }

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <NotFoundIllustration className={styles.illustration} />
        <div className={styles.textBlock}>
          <h1 className={styles.title}>Oops! Page not found</h1>
          <p className={styles.subtitle}>
            We can&apos;t find the page you&apos;re looking for.
          </p>
          <p className={styles.body}>
            If someone sent you a playlist or track link, ask them to resend it
            — it might have moved. Still stuck? Hit up{' '}
            <a
              href="mailto:support@disco.ac"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              support@disco.ac
            </a>
            <span className={styles.linkPeriod}>.</span>
          </p>
        </div>
      </div>
    </div>
  )
}
